<template>
  <div class="page">
    <img class="m-img" src="@/assets/img/home/Groups973.png" alt="">
    <span class="m-span">您的人证信息核验失败</span>
    <p class="m-p">很抱歉，本次人脸认证未通过，请您稍后再试</p>
    <van-button block class="x-btn-log m-btn-next" @click="getUrlBaiDu()">重新认证</van-button>
  </div>
</template>

<script>
  export default {
    components: {},
    data () {
      return {}
    },
    created () {

    },
    methods: {
      //获取百度的活体地址
      getUrlBaiDu(){
        this.http.postRequest({
          url: 'app/userInfo/h5Auth',
          msg: {idCardNum:this.$route.query.idCardNum},
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            this.utils.toastNone(res.msg||res.code)
          }
          if(res.code==200){
            if(res.data){
              let vt = res.data.split('token=')[1]
              let succsessUrl = `${window.location.origin}/appSuccess`
              let failedUrl = `${window.location.origin}/appFail`
              if(this.$route.query.idCardNum){
                succsessUrl = succsessUrl+'?idCardNum='+this.$route.query.idCardNum+'&vt='+vt
                failedUrl = failedUrl+'?idCardNum='+this.$route.query.idCardNum+'&vt='+vt
              } else {
                this.utils.toastNone('缺少参数！')
                return
              }
              let baiDu = `${res.data}&successUrl=${encodeURIComponent(succsessUrl)}&failedUrl=${encodeURIComponent(failedUrl)}`
              window.location.href = baiDu
            } else {
              this.utils.toastNone('缺少链接地址！')
            }
          }
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .m-img{
      width: 123px;
      height: 123px;
      margin-top: 73px;
    }
    .m-span{
      font-size: 16px;
      font-weight: bold;
      margin-top: 50px;
    }
    .m-p{
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
    }
    .m-btn-next{
      width: 210px;
      margin-top: 54px;
    }
  }
</style>

